import { render, staticRenderFns } from "./ReworkDialog.vue?vue&type=template&id=452ccc14"
import script from "./ReworkDialog.vue?vue&type=script&lang=js"
export * from "./ReworkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports